// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__vXUd2","title":"Images45_title__cQ8-i","images":"Images45_images__2qhVl"};